var HOST = '';
var MAU_URL = '';
if (process.env.REACT_APP_NODE_ENV === 'development') {
    HOST = 'https://adminmau.schoolmedia.id';
    MAU_URL = 'https://mau.schoolmedia.id';
}
if (process.env.REACT_APP_NODE_ENV === 'staging') {
    HOST = 'https://adminmaudev.schoolmedia.my.id';
    MAU_URL = 'https://maudev.schoolmedia.my.id';
}
if (process.env.REACT_APP_NODE_ENV === 'production') {
    HOST = 'https://adminmau.schoolmedia.id';
    MAU_URL = 'https://mau.schoolmedia.id';
}

export const HOSTNAME = HOST;
export const MAUURL = MAU_URL;